import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CtaButtonProps = {
  label: string;
  sublabel?: string;
  size?: 'md' | 'lg';
  className?: string;
};
export function CtaButton({
  label,
  sublabel,
  size = 'lg',
  className = ''
}: CtaButtonProps) {
  return <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className={`group inline-flex w-full max-w-xl flex-col items-center justify-center rounded-2xl bg-shield-500 text-ink-950 shadow-glow transition-transform duration-200 hover:-translate-y-0.5 hover:bg-shield-400 focus:outline-none focus-visible:ring-4 focus-visible:ring-shield-500/40 ${size === 'lg' ? 'px-6 py-5' : 'px-5 py-4'} ${className}`} data-id="element-23" data-mp="cjr9i0yr21ss">
      <span className={`flex items-center gap-2 text-center font-display font-extrabold uppercase leading-tight tracking-tight ${size === 'lg' ? 'text-base sm:text-xl' : 'text-sm sm:text-base'}`} data-id="element-24" data-mp="vclime9oyzp3">
        {label}
        <ArrowRightIcon className="hidden h-5 w-5 shrink-0 transition-transform duration-200 group-hover:translate-x-1 sm:block" aria-hidden="true" data-id="element-25" data-mp="15bazq4trkg4a" />
      </span>
      {sublabel ? <span className="mt-1 text-xs font-semibold uppercase tracking-widest text-ink-950/70" data-id="element-26" data-mp="39zsv3ymtr98n">
          {sublabel}
        </span> : null}
    </a>;
}